import React from 'react';
import { Card, Text, Badge, Flex, Box, Progress, Group } from '@mantine/core'
import dayjs from 'dayjs'
import 'dayjs/locale/es'
import relativeTime from 'dayjs/plugin/relativeTime'
dayjs.locale('es')
dayjs.extend(relativeTime)

const RowRenovation = ({ item, today }) =>
{
  const hoy = Date.parse(today);
  const limit_date_billing = Date.parse(dayjs(item?.limit_date_billing).format('YYYY-MM-DD'))

  const getRemainingDays = () =>
  {
    const hoursDiff = dayjs(item?.limit_date_billing).diff(dayjs(), 'hour');
    if (hoy === limit_date_billing) return '0';
    if (hoursDiff >= 0 && hoursDiff <= 24) return '1';
    return dayjs(item?.limit_date_billing).diff(dayjs(), 'day').toString();
  };

  const getProgressValue = () =>
  {
    const days = parseInt(getRemainingDays());
    if (days >= 10) return 0;
    if (days <= 0) return 100;
    return 100 - (days * 10); // Linear scale: 10 days = 0%, 0 days = 100%
  };

  const isToday = hoy === limit_date_billing;
  const remainingDays = parseInt(getRemainingDays());

  return (
    <Box
      p="xs"
      style={ {
        borderBottom: '1px solid var(--mantine-color-gray-1)',
        backgroundColor: isToday ? 'var(--mantine-color-orange-0)' : 'var(--mantine-color-white)',
        borderLeft: isToday ? '4px solid var(--mantine-color-orange-filled)' : '4px solid transparent',
        transition: 'all 0.2s ease',
      } }
    >
      <Flex justify="space-between" align="center" gap="md">
        {/* Left: Priority & ID */ }
        <Group gap="xs" style={ { flex: 1 } }>
          <Box
            px={ 6 } py={ 2 }
            style={ {
              backgroundColor: isToday ? 'var(--mantine-color-orange-filled)' : 'var(--mantine-color-gray-1)',
              color: isToday ? 'white' : 'inherit',
              borderRadius: '2px',
              fontFamily: 'var(--mantine-font-family-monospace)',
              fontSize: '11px',
              fontWeight: 800
            } }
          >
            { item.num_account }
          </Box>
          <Box>
            <Flex align="center" gap={ 6 }>
              <Text size="sm" fw={ 700 } style={ { lineHeight: 1.2 } }>{ item.full_name }</Text>
              { isToday && <Badge size="xs" color="orange" radius="xs" variant="filled">URGENTE</Badge> }
            </Flex>
            <Text size="10px" c="dimmed" tt="uppercase" fw={ 700 }>Siguiente ciclo de facturación</Text>
          </Box>
        </Group>

        {/* Center: Progress Signature */ }
        <Box style={ { width: '150px' } }>
          <Flex justify="space-between" mb={ 4 }>
            <Text size="10px" fw={ 800 } c={ remainingDays <= 2 ? 'red' : 'dimmed' }>DÍAS RESTANTES</Text>
            <Text size="10px" fw={ 800 }>{ remainingDays }</Text>
          </Flex>
          <Progress
            value={ getProgressValue() }
            color={ isToday ? 'orange' : (remainingDays <= 2 ? 'red' : 'yellow') }
            size="4px"
            radius="xs"
          />
        </Box>

        {/* Right: Action Date */ }
        <Box style={ { minWidth: '120px', textAlign: 'right' } }>
          <Text size="xs" fw={ 800 } tt="uppercase">
            { dayjs(item?.limit_date_billing).locale('es').format('DD MMMM') }
          </Text>
          <Text size="10px" c="dimmed" fw={ 700 }>
            { dayjs(item?.limit_date_billing).fromNow() }
          </Text>
        </Box>
      </Flex>
    </Box>
  );
}

export default RowRenovation
